import { axiosInstanceV2 } from '../axios';

export async function fetchSubscriptionPlans(params = {}) {
	try {
		const token = localStorage.getItem('authToken');

		const { data } = await axiosInstanceV2.get(`/plans/`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return data?.data;
	} catch (error) {
		throw error;
	}
}

export async function proceedToCheckout(payload) {
	try {
		const token = localStorage.getItem('authToken');

		const { data } = await axiosInstanceV2.post(`/subscription/proceed-to-checkout`, payload, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		return data;
	} catch (error) {
		throw error;
	}
}

export async function testDowngradeToFree() {
	const token = localStorage.getItem('authToken');
	const { data } = await axiosInstanceV2.get('/worker/test-downgrade-to-free', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	return data;
}

export async function testDowngradeSubscription() {
	const token = localStorage.getItem('authToken');

	const { data } = await axiosInstanceV2.get('/worker/test-downgrade-subscription', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	return data;
}

export async function testFinalizeCancellation() {
	const token = localStorage.getItem('authToken');

	const { data } = await axiosInstanceV2.get('/worker/test-finalize-cancellation', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	return data;
}

// Schedules or immediately cancels the subscription. cancel_at_cycle_end=1
// (default) never touches Razorpay — it flags the row and schedules the
// finalize_cancellation job for current_end. cancel_at_cycle_end=0 cancels now.
export async function cancelSubscription({ cancel_at_cycle_end = 1, reasons = [] } = {}) {
	const token = localStorage.getItem('authToken');

	const { data } = await axiosInstanceV2.patch(
		'/subscription/cancel',
		{ cancel_at_cycle_end, reasons },
		{ headers: { Authorization: `Bearer ${token}` } },
	);

	return data;
}

// Confirms a just-completed payment against Razorpay and applies the result
// immediately, instead of waiting for the asynchronous webhook. Without this
// the app redirects before activation lands and shows the previous plan.
//
// Returns { status, razorpay_status, is_settled } — is_settled is false while
// the provider is still confirming, which the success page uses to poll.
export async function syncSubscription({ razorpay_subscription_id }) {
	const token = localStorage.getItem('authToken');

	const { data } = await axiosInstanceV2.post(
		'/subscription/sync',
		{ razorpay_subscription_id },
		{ headers: { Authorization: `Bearer ${token}` } },
	);

	return data?.data;
}

// Undoes a pending "cancel at cycle end" — never touched Razorpay, so this
// just removes the scheduled job. Subscription keeps renewing normally.
export async function undoScheduledCancellation() {
	const token = localStorage.getItem('authToken');

	const { data } = await axiosInstanceV2.post(
		'/subscription/undo-scheduled-cancellation',
		{},
		{ headers: { Authorization: `Bearer ${token}` } },
	);

	return data;
}
